var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading && _vm.user)?_c('div',{staticClass:"show-md btn btn-action btn-primary s-circle",on:{"click":_vm.copyFiliationURL}},[_c('i',{staticClass:"fas fa-clipboard"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }